import $ from 'jquery';
import Cart from './cart';
export class CartProduct {
	constructor(cart, element, miniElement) {
        /** @type Cart */
		this.cart = cart;
		this.element = $(element);
		this.miniElement = $(miniElement);
		this.sku = this.element.data('product-sku');
		this.quantityInput = this.element.find('.quantity-container input');
		this.quantity = parseInt(this.quantityInput.val());
		if (isNaN(this.quantity) || this.quantity < 0) {
			this.quantity = 1;
			this.quantityInput.val(this.quantity);
		}
		this.element.find('button.decrement').click(this.buttonDecrementClicked.bind(this));
		this.element.find('button.increment').click(this.buttonIncrementClicked.bind(this));
		this.quantityInput.change(this.quantityChanged.bind(this));
		
		this.regularPriceElement = this.element.find('.regular-price');
		
		this.promotionalPriceElement = this.element.find('.promotional-price');
		this.promotionElement = $(this.promotionalPriceElement.parents('.price_row')[0]);
		
		this.discountElement = this.element.find('.discount');
		this.discountedPriceElement = this.discountElement.find('.price');
		
		this.discountCodeElement = this.element.find('.discount_code_row');
		this.volumeDiscountElement = this.element.find('.volume_discount_row');
		
		this.totalPriceElement = this.element.find('.total .price');
		this.totalTextElement = this.element.find('.total .lbl');
	}
	
	buttonDecrementClicked(event) {
		event.preventDefault();
		this.updateProductQuantity(-1);
	}
	
	buttonIncrementClicked(event) {
		event.preventDefault();
		this.updateProductQuantity(+1);
	}
	
	updateProductQuantity(change) {
		let newQuantity = this.quantity + change;
		if (newQuantity < 0)
			return;
		this.cart.updateProductQuantity(this.sku, newQuantity);
	}
	
	quantityChanged(event) {
		let newQuantity = parseInt(this.quantityInput.val());
		if (isNaN(newQuantity) || newQuantity < 0) {
			newQuantity = 1;
		}
		this.quantityInput.val(newQuantity);
		this.cart.updateProductQuantity(this.sku, newQuantity);
	}
	
	updateFromServer(data) {
		//console.log(data);
		this.quantity = data.quantity;
		this.quantityInput.val(this.quantity);
		
		this.regularPriceElement.text(data.prices.regular);
		this.promotionalPriceElement.text(data.prices.promotional);
		this.discountedPriceElement.text(data.prices.discounted);
		
		let hasPromotion = data.prices.promotional != null;
		let hasDiscountCode = data.discountCode != null
		let discountCodeApplies = hasDiscountCode && data.prices.discount != null;
		
		let hasVolumeDiscount = data.prices.volumeDiscount != null;
		
		let hasDiscount = (hasDiscountCode && discountCodeApplies) || hasVolumeDiscount;
		
		this.regularPriceElement.toggleClass('strike', hasPromotion || hasDiscount);
		this.promotionalPriceElement.toggleClass('strike', hasDiscount);
		this.discountElement.toggleClass('hidden', !hasDiscount);
		this.volumeDiscountElement.toggleClass('hidden', !hasVolumeDiscount);
		this.promotionElement.toggleClass('hidden', !hasPromotion);

		this.volumeDiscountElement.find('span.price').text(data.prices.volumeDiscount);
		
		if (hasDiscountCode) {
			this.discountCodeElement.find('span.lbl span').text(data.discountCode.code);
			if (discountCodeApplies) {
				this.discountCodeElement.find('span.price').text(data.discountCode.discount);
			} else {
				this.discountCodeElement.find('span.price').text('Not Applicable');
			}
		} else {
			this.discountCodeElement.find('span.lbl span').text('');
			this.discountCodeElement.find('span.price').text('');
		}
		
		this.totalPriceElement.text(data.prices.finalWithQuantity);
		this.totalTextElement.text(data.totalText);
		
		this.miniElement.find('span.quantity').text(this.quantity);
		this.miniElement.find('span.price').text(data.prices.finalWithQuantity);
	}
}